import { render } from "./CampusMapCard.vue?vue&type=template&id=7079d054&scoped=true"
import script from "./CampusMapCard.vue?vue&type=script&lang=js"
export * from "./CampusMapCard.vue?vue&type=script&lang=js"

import "./CampusMapCard.vue?vue&type=style&index=0&id=7079d054&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7079d054"]])

export default __exports__